/**
 * Server/API uses UTC (ISO 8601). Calendar UIs show local wall time for the same instant.
 * Parsing uses date-fns; serializing instants for the API uses `Date#toISOString()` (UTC with `Z`, may include milliseconds).
 */

import { getUnixTime, isValid, parseISO } from 'date-fns';

/** Parse API UTC string to `Date` (picker shows local equivalent of that instant). */
export function utcIsoToLocalDate(iso: string | null | undefined): Date | null {
  if (iso == null || iso === '') {
    return null;
  }
  const d = parseISO(iso);
  return isValid(d) ? d : null;
}

/**
 * Serialize picker `Date` (instant) to ISO 8601 UTC with `Z` (Zulu), e.g. `2026-06-15T14:00:00.000Z`.
 */
export function localDateToUtcIso(d: Date): string {
  return d.toISOString();
}

/** Compare API UTC string to another ISO string (second precision). */
export function isSameUtcInstantString(
  apiValue: string | null | undefined,
  utcIso: string,
): boolean {
  if (apiValue == null || apiValue === '') {
    return false;
  }
  const a = parseISO(apiValue);
  const b = parseISO(utcIso);
  if (!isValid(a) || !isValid(b)) {
    return false;
  }
  return getUnixTime(a) === getUnixTime(b);
}
